import * as S from './ThemeSwitcher.style';

export { default as ThemeSwitcher } from './ThemeSwitcher';
export * from './ThemeSwitcher.types';
export { S };
